import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=c2004672&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2004672')) {
      api.createRecord('c2004672', component.options)
    } else {
      api.reload('c2004672', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=c2004672&", function () {
      api.rerender('c2004672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/checkbox/src/checkbox.vue"
export default component.exports